export const LEGAL_DOC_KEYS = [
  "esign",
  "privacyPolicy",
  "leapPrivacyNotice",
  "crbPrivacyNotice",
  "userAgreement",
  "transactionPolicy",
] as const;

export type LegalDocKey = (typeof LEGAL_DOC_KEYS)[number];
export type LegalLang = "en" | "es";
